function _viewport() {
    var e = window, a = 'inner';
    if (!('innerWidth' in window )) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    //return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
  return  e[ a+'Width' ];
}


jQuery(document).ready(function(){
  $('.see-more').click(function() {
  	$('.show-brand-fix').toggleClass('seemoreless');
    $('.show-more-brands').toggleClass('hide-brands');
    $(this).toggleClass('see-fix');
    return false;
  });
  
  if($(".product-owl").length > 0) {  
  $(".product-owl").owlCarousel({
      items : 4,
      scrollPerPage : true,
      itemsDesktop : [1000,4], //5 items between 1000px and 901px
      itemsDesktopSmall : [900,3], // betweem 900px and 601px
      itemsTablet: [600,2], //2 items between 600 and 0;
      itemsMobile :[479,1] // itemsMobile disabled - inherit from itemsTablet option
    
  });
  }
  
  $(".brands-owl").owlCarousel({
    items : 5,
      scrollPerPage : true,
      itemsDesktop : [1000,5], //6 items between 1000px and 901px
      itemsDesktopSmall : [900,4], // betweem 900px and 601px
      itemsTablet: [600,3], //2 items between 600 and 0;
      itemsMobile :[479,1] // itemsMobile disabled - inherit from itemsTablet option
    
  });
  
	bindGrid();
  
  if( _viewport() < 768 ){
  	$('.top-right-products').insertAfter('span.model-product');
  }
  
});


jQuery(window).load(function() {
  
  
    $('.title-footer').click(function() {
      if( _viewport() < 768 ){
        $(this).toggleClass('active-title-footer').parent().find('.toogle-content-footer').toggleClass('show-mobile-footer');
          }
    });
  
  
  
      $('.title-filter').click(function() {
      if( _viewport() < 768 ){
        $(this).toggleClass('active-title-filter').parent().find('.show-mobile').toggleClass('show-mobile-collection');
          }
    });
	
  	var max_height_fix = 0 ;
    $('div#products-viewmode div.item').each(function(){
       if($(this).height() > max_height_fix){
        max_height_fix = $(this).height();

       }
    });
        $('div#products-viewmode div.item').css("min-height",(max_height_fix+85)+'px'); 


});



/* Remove wishlist */
    jQuery(".btn-remove-wishlist").click(function(n) {
    var r = jQuery(this).parents("tr");
    var i = r.find(".tag-id").val();
    var s = jQuery("#remove-wishlist-form");
    s.find("input[name='contact[tags]']").val("x" + i);
    jQuery.ajax({
      type: "POST",
      url: "/contact",
      data: s.serialize(),
      success: function(e) {
        r.fadeOut(1e3)
      }
    })
  });
  /* End Remove wishlist */

